<ul class="bf-list" [class.selectable]="selectable" [ngClass]="size">
  <ng-content></ng-content>
</ul>
